import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import PropTypes from "prop-types";

function CustomSkeleton({ color, width, height, count, circle }) {
  return (
    <SkeletonTheme color={color}>
      <Skeleton circle={circle} width={width} height={height} count={count} />
    </SkeletonTheme>
  );
}

CustomSkeleton.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
};

CustomSkeleton.defaultProps = {
  color: "#eaeaea",
  count: 1,
};

export default CustomSkeleton;
